import { Component, Input, Output, EventEmitter } from '@angular/core';
import { BackgroundColorMap } from '../../../constants-types/ColorPalettePicker.model';
import { Person } from '../../../core-data-model/Person.model';
import { TranslationService } from '../../../translations';

@Component({
    selector: 'color-palette-picker',
    template: `
        <div
            tooltip-on-click
            [tooltipContent]="colorTooltip"
            tooltipPlacement="bottom"
            [tooltipShow]="showPicker && person.hasBehavioralPattern()"
            (click)="togglePicker()"
        ></div>
        <div>
            <tooltip-content #colorTooltip>
                <div
                    (clickOutside)="focusLost()"
                    style="text-align:left; margin-top:10px"
                >
                    <div class="colorPaletteContent">
                        {{ TR.key('colorpalettepicker.setcolor') }}
                    </div>
                    @for (color of availableColors; track color) {
                        <label
                            class="colorBox"
                            [ngClass]="backgroundColorMap[color]"
                            (click)="colorPicker(color)"
                        ></label>
                    }
                </div>
            </tooltip-content>
        </div>
    `,
    standalone: false
})
export class ColorPalettePickerComponent {
    @Input()
    colors: string;
    @Input()
    showPicker = false;
    @Input()
    person: Person;
    @Input()
    index: number;

    @Output()
    selectedColor = new EventEmitter<number>();
    @Output()
    pickerToggled = new EventEmitter<number>();

    backgroundColorMap = BackgroundColorMap;
    // Use numeric enum keys instead of string keys so template passes number to colorPicker
    availableColors: number[];

    constructor(public TR: TranslationService) {
        // Object.keys returns string[], convert to numeric enum members
        this.availableColors = Object.keys(this.backgroundColorMap).map((k) =>
            Number(k)
        );
        // Remove reserved error color (last enum value) so it doesn't show up in picker
        this.availableColors.pop();
    }

    focusLost() {
        this.pickerToggled.emit();
    }

    colorPicker(color: number) {
        this.selectedColor.emit(color);
        this.togglePicker();
    }

    togglePicker() {
        this.pickerToggled.emit(this.index);
        this.showPicker = !this.showPicker;
    }
}
